"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useAreFavoritesEnabled = require("./useAreFavoritesEnabled");
Object.keys(_useAreFavoritesEnabled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useAreFavoritesEnabled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useAreFavoritesEnabled[key];
    }
  });
});
var _useGetAvailableRewardShopPoints = require("./useGetAvailableRewardShopPoints");
Object.keys(_useGetAvailableRewardShopPoints).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetAvailableRewardShopPoints[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetAvailableRewardShopPoints[key];
    }
  });
});
var _useInitialDisclose = require("./useInitialDisclose");
Object.keys(_useInitialDisclose).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useInitialDisclose[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useInitialDisclose[key];
    }
  });
});
var _useIsMobile = require("./useIsMobile");
Object.keys(_useIsMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useIsMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useIsMobile[key];
    }
  });
});
var _useWindowSize = require("./useWindowSize");
Object.keys(_useWindowSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useWindowSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useWindowSize[key];
    }
  });
});
var _useListenToKeyDown = require("./useListenToKeyDown");
Object.keys(_useListenToKeyDown).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useListenToKeyDown[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useListenToKeyDown[key];
    }
  });
});
var _useDisclose = require("./useDisclose");
Object.keys(_useDisclose).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useDisclose[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useDisclose[key];
    }
  });
});
var _useGlobalEvents = require("./useGlobalEvents");
Object.keys(_useGlobalEvents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGlobalEvents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGlobalEvents[key];
    }
  });
});
var _useHideNextJsErrorOverlay = require("./useHideNextJsErrorOverlay");
Object.keys(_useHideNextJsErrorOverlay).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useHideNextJsErrorOverlay[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useHideNextJsErrorOverlay[key];
    }
  });
});
//# sourceMappingURL=index.js.map